<template>
	<div id="page-customer" class="vx-card p-6">
		<!-- AgGrid Table -->
		<ag-grid-vue
			id="myGrid"
			ref="agGridTable"
			:gridOptions="gridOptions"
			class="ag-theme-material w-100 my-4 ag-grid-table database"
			:columnDefs="columnDefs"
			:defaultColDef="defaultColDef"
			:rowData="customersData"
			colResizeDefault="shift"
			:animateRows="true"
			:pagination="true"
			:domLayout="domLayout"
			:paginationPageSize="paginationPageSize"
			:suppressPaginationPanel="true"
			:enableRtl="$vs.rtl"
			:overlayNoRowsTemplate="noRowsTemplate"
			:detailRowAutoHeight="true"
		>
		</ag-grid-vue>

		<div style="position: relative">
			<!-- pagination -->
			<vs-pagination :total="totalPages" v-model="currentPage" :max="5" class="pr-10 pt-10" />
		</div>
	</div>
</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import { AgGridVue } from 'ag-grid-vue'
import { mapGetters } from 'vuex'

import { CUSTOMER_TYPE, GENDER_TYPE } from '@/enums/customer'

export default {
	components: {
		AgGridVue
	},
	data() {
		return {
			fileImportError: {
				message: '',
				flag: false
			},
			// Filter Options
			filterCustomers: {
				id: null,
				name: null,
				email: null,
				phone_number: null,
				customer_type: null,
				company_name: null,
				industry_name: null,
				address: null
			},
			customerType: [
				{ key: CUSTOMER_TYPE.INDIVIDUAL.value, value: CUSTOMER_TYPE.INDIVIDUAL.name },
				{ key: CUSTOMER_TYPE.CORPORATE.value, value: CUSTOMER_TYPE.CORPORATE.name },
				{ key: CUSTOMER_TYPE.DEALER.value, value: CUSTOMER_TYPE.DEALER.name },
				{ key: CUSTOMER_TYPE.BRANCH.value, value: CUSTOMER_TYPE.BRANCH.name },
				{ key: CUSTOMER_TYPE.OTHER.value, value: CUSTOMER_TYPE.OTHER.name }
			],
			customerTypeFilter: [{ key: null, value: '...' }],
			genderType: [
				{ key: GENDER_TYPE.MEN.value, value: GENDER_TYPE.MEN.name },
				{ key: GENDER_TYPE.WOMEN.value, value: GENDER_TYPE.WOMEN.name },
				{ key: GENDER_TYPE.OTHER.value, value: GENDER_TYPE.OTHER.name }
			],
			paginationOptions: [10, 100, 500, 1000],

			//Pagination
			paginationPageSize: 10,
			pageNumber: 1,

			// AgGrid
			noRowsTemplate: '<span>データがありません</span>',
			domLayout: 'autoHeight',
			gridApi: null,
			gridOptions: {
				onGridSizeChanged: () => {
					this.gridApi.sizeColumnsToFit()
				},
				onRowDoubleClicked: ({ data }) => {
					this.$emit('selectCustomer', data)
				}
				// onRowClicked: (e) => {}
			},
			defaultColDef: {
				sortable: false,
				resizable: true,
				suppressMenu: true,
				sortingOrder: ['asc', 'desc'],
				wrapText: true,
				autoHeight: true
			},
			columnDefs: [
				{
					headerName: 'ID',
					field: 'id',
					width: 150,
					filter: true,
					sort: 'desc',
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '名前',
					field: 'name',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: 'よみがな',
					field: 'name_kana',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: 'メールアドレス',
					field: 'email',
					filter: true,
					width: 225,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '電話',
					field: 'phone_number',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: 'お客様種別',
					field: 'customer_type',
					filter: true,
					width: 140,
					unSortIcon: true,
					comparator: (val1, val2) => val1 - val2,
					suppressMovable: true
				},
				{
					headerName: '会社名',
					field: 'company_name',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: 'よみがな',
					field: 'company_name_kana',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '性別',
					field: 'gender_text',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '業種名',
					field: 'industry_name',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '郵便番号',
					field: 'postal_code',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '都道府県',
					field: 'prefecture_name',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '住所',
					field: 'address',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: 'FAX',
					field: 'fax_number',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				},
				{
					headerName: '備考',
					field: 'remarks',
					filter: true,
					width: 170,
					unSortIcon: true,
					suppressMovable: true
				}
			],

			initialCustomer: {
				id: null,
				last_name: '',
				first_name: '',
				last_name_kana: '',
				first_name_kana: '',
				email1: '',
				email2: '',
				phone_number1: '',
				phone_number2: '',
				customer_type_flg: 0,
				company_name: '',
				company_name_kana: '',
				gender: 0,
				industry_name: '',
				department_name: '',
				postal_name: '',
				prefecture_name: '',
				address: '',
				fax_number: '',
				mail_domain: '',
				retailer_name: '',
				remarks: ''
			},
			prefectureOptions: [
				{ key: 0, value: '北海道' },
				{ key: 1, value: '青森県' },
				{ key: 2, value: '岩手県' },
				{ key: 3, value: '宮城県' },
				{ key: 4, value: '秋田県' },
				{ key: 5, value: '山形県' },
				{ key: 6, value: '福島県' },
				{ key: 7, value: '茨城県' },
				{ key: 8, value: '栃木県' },
				{ key: 9, value: '群馬県' },
				{ key: 10, value: '埼玉県' },
				{ key: 11, value: '千葉県' },
				{ key: 12, value: '東京都' },
				{ key: 13, value: '神奈川県' },
				{ key: 14, value: '新潟県' },
				{ key: 15, value: '富山県' },
				{ key: 16, value: '石川県' },
				{ key: 17, value: '福井県' },
				{ key: 18, value: '山梨県' },
				{ key: 19, value: '長野県' },
				{ key: 20, value: '岐阜県' },
				{ key: 21, value: '静岡県' },
				{ key: 22, value: '愛知県' },
				{ key: 23, value: '三重県' },
				{ key: 24, value: '滋賀県' },
				{ key: 25, value: '京都府' },
				{ key: 26, value: '大阪府' },
				{ key: 27, value: '兵庫県' },
				{ key: 28, value: '奈良県' },
				{ key: 29, value: '和歌山県' },
				{ key: 30, value: '鳥取県' },
				{ key: 31, value: '島根県' },
				{ key: 32, value: '岡山県' },
				{ key: 33, value: '広島県' },
				{ key: 34, value: '山口県' },
				{ key: 35, value: '徳島県' },
				{ key: 36, value: '香川県' },
				{ key: 37, value: '愛媛県' },
				{ key: 38, value: '高知県' },
				{ key: 39, value: '福岡県' },
				{ key: 40, value: '佐賀県' },
				{ key: 41, value: '長崎県' },
				{ key: 42, value: '熊本県' },
				{ key: 43, value: '大分県' },
				{ key: 44, value: '宮崎県' },
				{ key: 45, value: '鹿児島県' },
				{ key: 46, value: '沖縄県' },
			]
		}
	},
	props: {
		pageCustomer: { type: Number, default: 1 }
	},
	watch: {
		async paginationPageSize(val) {
			await this.setPagination(val)
		},
		async pageCustomer(page) {
			this.currentPage = page
			await this.fetchCustomerList(page)
		}
	},
	computed: {
		...mapGetters({
			customers: 'customer/customers'
		}),
		customersData() {
			let customersData = []
			this.customers.forEach((elem) => {
				let name = [elem.last_name, elem.first_name].filter((item) => item).join(' ')
				let name_kana = [elem.last_name_kana, elem.first_name_kana].filter((item) => item).join(' ')
				let phone_number = [elem.phone_number1, elem.phone_number2].filter((item) => item).join(', ')
				let email = [elem.email1, elem.email2].filter((item) => item).join(', ')
				const customer_type_object = this.customerType.find((item) => item.key === elem.customer_type_flg)
				let customer_type = ''
				if (customer_type_object) customer_type = customer_type_object.value
				let gender_text = elem.gender === 0 ? '男' : elem.gender === 1 ? '女' : 'その他'
				customersData.push(Object.assign({ name, name_kana, phone_number, email, customer_type, gender_text }, elem))
			})
			return customersData
		},
		totalPages() {
			return parseInt(this.$store.state.customer.infoDB.totalPage)
		},
		currentPage: {
			get() {
				return this.pageNumber
			},
			async set(val) {
				this.pageNumber = val
				await this.fetchCustomerList(val)
				this.ids = []
				this.gridApi.paginationGoToPage(val - 1)
			}
		}
	},
	methods: {
		// import customer
		async resetColFilters() {
			// Reset Grid Filter
			this.gridApi.setFilterModel(null)
			this.gridApi.onFilterChanged()
			;(this.filterCustomers = {
				id: null,
				name: null,
				email: null,
				phone_number: null,
				customer_type: null,
				company_name: null,
				industry_name: null,
				address: null
			}),
				(this.ids = [])
			await this.fetchCustomerList()
			this.$refs.filterCard.removeRefreshAnimation()
		},
		async setPagination(val) {
			this.gridApi.paginationSetPageSize(val)
			this.pageNumber = 1
			this.fetchCustomerList(val) //let change
			this.ids = []
		},
		fetchCustomerList(val) {
			this.$emit('changePage', val)
		}
	},
	mounted() {
		this.gridApi = this.gridOptions.api
		this.customerTypeFilter.push(...this.customerType)
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
		}
	},
}
</script>
<style lang="scss">
@import '@/assets/scss/vuexy/components/view/customer.scss';
:root {
	/* Dropdown */
	--vs-dropdown-max-height: 205px !important;
}
</style>
